import { Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";

// Counts down to: 13-02-2026 18:00 CEST (UTC+02:00)
// Note: February is typically CET in Europe, but this uses CEST exactly as requested.

function pad2(n) {
  return String(n).padStart(2, "0");
}

function formatParts(ms) {
  const clamped = Math.max(0, ms);
  const totalSeconds = Math.floor(clamped / 1000);

  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return { days, hours, minutes, seconds };
}

export default function BigCountdownTimer() {
  // 2026-02-13 18:00 at UTC+02:00 => 2026-02-13 16:00:00Z
  const targetMs = useMemo(() => Date.UTC(2026, 1, 13, 16, 0, 0), []);

  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 200);
    return () => clearInterval(id);
  }, []);

  const remainingMs = targetMs - now;
  const { days, hours, minutes, seconds } = formatParts(remainingMs);

  const done = remainingMs <= 0;

  const timeText = done
    ? "00:00:00:00"
    : `${days}:${pad2(hours)}:${pad2(minutes)}:${pad2(seconds)}`;

  return (
    <div className="relative min-h-[55vh] w-full flex items-center justify-center overflow-hidden p-6">
      {/* soft, fancy background */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-24 -left-24 h-80 w-80 rounded-full bg-neutral-200/60 blur-3xl" />
        <div className="absolute -bottom-32 -right-24 h-[28rem] w-[28rem] rounded-full bg-neutral-300/50 blur-3xl" />
        <div className="absolute inset-0 bg-gradient-to-b from-white via-white to-neutral-50" />
      </div>

      <div className="relative w-full max-w-5xl">
        <div className="relative rounded-[2.25rem] border border-neutral-200/70 bg-white/55 shadow-[0_25px_70px_-35px_rgba(0,0,0,0.35)] backdrop-blur-xl px-6 py-10 sm:px-10 sm:py-14">
          {/* subtle shine */}
          <div className="pointer-events-none absolute inset-0 rounded-[2.25rem] bg-gradient-to-br from-white/40 via-white/10 to-transparent" />

          <div className="relative flex flex-col items-center">
            {/* Big time only */}
            <div className="font-mono tracking-[-0.06em] text-neutral-950 select-none">
              <div
                className="text-[3.2rem] leading-none sm:text-[4.6rem] md:text-[6.2rem] lg:text-[7.8rem] xl:text-[9rem] font-semibold"
                style={{ fontVariantNumeric: "tabular-nums" }}
                aria-label="Time left"
              >
                <Typography variant="h1">{timeText}</Typography>
              </div>
            </div>

          </div>
        </div>

        {/* micro caption */}

      </div>
    </div>
  );
}
